import type { FC } from 'react'

import { Input } from '@skytech/ui'
import { Disclosure } from '@skytech/ui/Disclosure'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import { Translation } from '@/app/translations/Translation'

export const Accounting: FC = () => (
  <>
    <Field name="accountingCode">
      {({ field, meta }: FieldProps) => (
        <Input
          isFullWidth
          id="accountingCode"
          label={<Translation id="Accounting code" />}
          marginBottom={16}
          error={meta.error}
          touched={meta.touched}
          {...field}
        />
      )}
    </Field>

    <Disclosure>
      {({ open }) => (
        <>
          <Disclosure.Button isOpen={open} className="justify-center px-0">
            <Translation id="Show Dim-values" />
          </Disclosure.Button>

          <Disclosure.Panel className="p-0">
            <Field name="dim1">
              {({ field, meta }: FieldProps) => (
                <Input
                  isFullWidth
                  id="dim1"
                  label={<Translation id="Dim 1" />}
                  marginBottom={16}
                  error={meta.error}
                  touched={meta.touched}
                  {...field}
                />
              )}
            </Field>
            <Field name="dim2">
              {({ field, meta }: FieldProps) => (
                <Input
                  isFullWidth
                  id="dim2"
                  label={<Translation id="Dim 2" />}
                  marginBottom={16}
                  error={meta.error}
                  touched={meta.touched}
                  {...field}
                />
              )}
            </Field>

            <Field name="dim3">
              {({ field, meta }: FieldProps) => (
                <Input
                  isFullWidth
                  id="dim3"
                  label={<Translation id="Dim 3" />}
                  marginBottom={16}
                  error={meta.error}
                  touched={meta.touched}
                  {...field}
                />
              )}
            </Field>
            <Field name="dim4">
              {({ field, meta }: FieldProps) => (
                <Input
                  isFullWidth
                  id="dim4"
                  label={<Translation id="Dim 4" />}
                  marginBottom={16}
                  error={meta.error}
                  touched={meta.touched}
                  {...field}
                />
              )}
            </Field>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  </>
)
